export const QuoteProductID = {
    BANNER_OPTERM_PRODUCT_ID: 1000, 
    PACIFIC_LIFE_PROMISE_TERM_PRODUCT_ID: 1005, 
    PENN_OPTERM_PRODUCT_ID: 1016, 
    AMERICO_TERM_PRODUCT_ID: 1017,
    HAVEN_TERM_PRODUCT_ID: 1031,
    BESTOW_PRODUCT_ID: 1032,
    LGA_PRODUCT_ID: 1033,
    HAVEN_SI_PRODUCT_ID: 1038,
    SYMETRA_SWIFT_TERM_PRODUCT_ID: 1039, 
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/QuoteProductID.js